import {
  adminTenantId,
  cloudApiIndicator,
  CloudScope,
  getManagementApiResourceIndicator,
  PredefinedScope,
} from '@logto/schemas';
import { appendPath } from '@silverhand/essentials';

import { isCloud } from './env';
import { adminTenantEndpoint } from './tenants';

export type ApiResource = {
  indicator: string;
  scopes: Record<string, string>;
};

export const getManagementApi = (tenantId: string) =>
  Object.freeze({
    indicator: getManagementApiResourceIndicator(tenantId),
    scopes: PredefinedScope,
  } satisfies ApiResource);

/** Me API indicator: in OSS uses current origin (/me) so custom domain works. */
export const getMeApiIndicator = () =>
  isCloud
    ? getManagementApiResourceIndicator(adminTenantId, 'me')
    : appendPath(adminTenantEndpoint, 'me').href;

export const meApi = Object.freeze({
  get indicator() {
    return getMeApiIndicator();
  },
  scopes: PredefinedScope,
} satisfies ApiResource);

export const cloudApi = Object.freeze({
  indicator: cloudApiIndicator,
  scopes: CloudScope,
} satisfies ApiResource);
